import React, { useState , useEffect} from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import Header from './header';
import Footer from './footer';
import './style/book.css';

function ManageBooking() {

  let history = useHistory()

  const [email, setEmail] = useState("");
  const [msg, setMessage] = useState("");
  const [msg1, set1Message] = useState("");
  const [status, setStatus] = useState(false);
  const [semail, setSEmail] = useState("");

  if(false)
  {
    //did this to remove warnings
      setEmail(email);
      setStatus(status);
  }
  const onChangeSEmail = (e) => setSEmail(e.target.value);

    const [list, setList] = useState([]);
    useEffect(()=> {
        axios.get('https://akshatngupta-bike-rental.herokuapp.com/booking')
      .then(response => {
        // 
        // if(response.data[0]==0)
        // setMessage("NO USERS PRESENT");
        if(semail==="")
        setList(response.data);
      })
      .catch((error) => {
        if(error.response.status===404)
          setList([]);
        console.log(error);
        set1Message('NO BOOKINGS EXISTS! PLEASE CHECK AFTER SOMETIME') 
      })
    })
    
    // const onChangeEmail = (e) => {
    //   setEmail(e.target.value);
    //   setMessage(''); //REMOVE ERROE MSG
    // }

    const handleSubmit = (evt) => {

      evt.preventDefault();
      console.log(`EMAIL: ${semail}`);
      axios.get('https://akshatngupta-bike-rental.herokuapp.com/booking/search/' + semail)
        .then(res => {
          console.log(res.data)
          setList(res.data)
          setStatus(true)
        })
        .catch(err => {
          console.log(err)
          setMessage('INVALID EMAIL ID')
        })

  
  
      // setEmail('')
    }
    const handleClick = event => {
      event.preventDefault();
      let values = event.target.dataset.mssg.split("_")
      if(values[1] === "Update"){
        sessionStorage.setItem('email',values[0])
        history.push(`/updatebooking/${values[0]}`
        )
        setMessage('SUCCESSFULLY UPDATED')
      }
      else{
        let email = values[0]
        axios.delete('https://akshatngupta-bike-rental.herokuapp.com/booking/remove/' + email)
        .then(res => {
          console.log(res.data)
          setMessage('SUCCESSFULLY DELETED')
        })
        .catch(err => {
          console.log(err)
          setMessage('INVALID USER ID')
        })

      }
      setEmail('')
    }
    
    return (
      <div>
      <Header />
      <div>
        <form className="shift">
        <table className="table table-adminUser">
          <thead className="thead-dark"> 
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>PickUp Date</th>
              <th>PickUp Time</th>
              <th>Drop Date</th>
              <th>Drop Time</th>
              <th>Rent</th>
              <th>Action</th>
              <th ><form onSubmit={handleSubmit}  >
        <input type="email"  value={semail} placeholder="EMAIL ID" onChange={onChangeSEmail} required />
        <input type="submit" value="SEARCH USER" onChange={onChangeSEmail} className="btn btn-danger" />
      </form></th>
            </tr>
          </thead>
          {list.map((currentrow,idx) => {
            return (<tr key={idx}>
              <td>{currentrow.name}</td>
              <td>{currentrow.email}</td>
              <td>{currentrow.sdate}</td>
              <td>{currentrow.stime}</td>
              <td>{currentrow.edate}</td>
              <td>{currentrow.etime}</td>
              <td>{currentrow.rent}</td>
              <td >
                <button type="button"  data-mssg={`${currentrow.email}_Update`}  onClick={handleClick} class="btn btn-primary btn-others">Update</button>
                <button type="button"  data-mssg={`${currentrow.email}_Delete`} onClick={handleClick} class="btn btn-danger btn-others">Delete</button>
              </td>
            </tr>
            )})}
        </table>
        </form>
      </div> 
      <div>
      <b style={{ color: "red" }}>{msg}</b>
      </div>
      <div>
      <b style={{ color: "red" }}>{msg1}</b>
      </div>
      <Footer />
      </div>
)}

export default ManageBooking
